module.exports = __webpack_public_path__ + "static/media/edgePng.4c6b4615.png";